module.exports = "/fonts/vendor/pe7-icon/dist/Pe-icon-7-stroke.ttf?7233a7aee250f9b77fba5f735143ad39";